import { useState } from 'react';

import { getClassName } from '@perpay-web/utils/domUtils';
import { isEnterOrSpaceKey } from '@perpay-web/utils/keyboardUtils';

import styles from './Accordion.scss';

const Accordion = ({ className, icon, heading, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => setIsOpen((prev) => !prev);

    return (
        <div className={getClassName(styles.accordion, className)}>
            <div
                className={styles.accordion__heading}
                onClick={toggleAccordion}
                onKeyDown={(event) => {
                    if (isEnterOrSpaceKey(event.key)) {
                        toggleAccordion();
                    }
                }}
                role='button'
                tabIndex='0'
            >
                {heading}
                <div
                    className={getClassName(
                        styles.heading__icon,
                        !icon && styles.heading__default,
                        styles[
                            `heading__icon--${isOpen ? 'opened' : 'closed'}`
                        ],
                    )}
                >
                    {icon || (
                        <div className={styles['heading__icon--default']} />
                    )}
                </div>
            </div>
            <div className={isOpen ? styles.visible : styles.invisible}>
                {children}
            </div>
        </div>
    );
};

export default Accordion;
